// import { ReportAllocatedAndSubsidies40Component } from "../../../components/SupportSystem/Reports/ReportAllocatedAndSubsidies40Component";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NewReportAllocatedAndSubsidies40Component } from "../../../components/SupportSystem/Reports/NewReportAllocatedAndSubsidies40Component";


export function ReportAllocatedAndSubsidies40Container() {
    const titleName = "ระบบการให้เงินช่วยเหลือหรืออุดหนุนกองทุนพัฒนาฝีมือแรงงาน";
    return(
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <NewReportAllocatedAndSubsidies40Component/>
            <Footer />
        </div>   
        // 
    )
    
}